var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { arrowDownLine, arrowUpLine, Icone } from "../../../fondamentaux/Icone";
import { TABLEAU_ORDRE_TRI_ASC, TABLEAU_ORDRE_TRI_DESC } from "../index";
var TableauHeaderCell = function (_a) {
    var children = _a.children, scope = _a.scope, ordreTri = _a.ordreTri, onClick = _a.onClick, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "scope", "ordreTri", "onClick", "className", "style"]);
    if (onClick) {
        var handleKeyDown = function (event) {
            if (onClick && (event.key === 'Enter' || event.key === '13')) {
                onClick();
            }
        };
        var styleGroup = __assign(__assign({}, style), { cursor: 'pointer' });
        return (React.createElement("th", __assign({}, otherProps, { scope: scope, onClick: function () { return onClick(); }, style: styleGroup, role: "button", onKeyDown: handleKeyDown, tabIndex: 0, className: className }),
            children,
            ordreTri === TABLEAU_ORDRE_TRI_ASC ? (React.createElement(Icone, { icone: arrowUpLine })) : null,
            ordreTri === TABLEAU_ORDRE_TRI_DESC ? (React.createElement(Icone, { icone: arrowDownLine })) : null));
    }
    return (React.createElement("th", __assign({}, otherProps, { scope: scope, className: className, style: style }),
        children,
        ordreTri === TABLEAU_ORDRE_TRI_ASC ? (React.createElement(Icone, { icone: arrowUpLine })) : null,
        ordreTri === TABLEAU_ORDRE_TRI_DESC ? (React.createElement(Icone, { icone: arrowDownLine })) : null));
};
export default TableauHeaderCell;
